<template>
  <div class="container-fluid px-0" ref="vehicleTab">
    <div class="row gx-10">
      <div class="col-4 d-flex flex-column">
        <div
          class="tw-px-[15px] tw-py-[10px] tw-rounded-[5px] tw-overflow-hidden tw-bg-white flex-grow-1"
        >
          <div class="tw-mb-[6px] d-flex">
            <span class="fsc-12 fw-bolder tw-text-forTitle">{{
              dataLang["vehicles-page__modal__tab-object__column-1__header"]
            }}</span>
          </div>
          <div
            class="d-flex align-items-center justify-content-between tw-mb-[6px]"
          >
            <span class="tw-app-input-container-label-type-2">
              {{ dataLang["vehicles-page__modal__tab-object__column-1__city"] }}
            </span>
            <div class="multiselect-type-2">
              <BaseSelect
                style="width: 302px"
                @input="setSelected"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                v-model="dataFromSelect.dataCity"
                id="city"
                label="cities__name"
                :options="optionsForSelect.cities"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template>
                <template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-between tw-mb-[6px]"
            ref="vehicles__place_id"
          >
            <span class="tw-app-input-container-label-type-2">
              {{
                dataLang["vehicles-page__modal__tab-object__column-1__place"]
              }}
            </span>
            <div class="multiselect-type-2">
              <BaseSelect
                style="width: 302px"
                @input="setSelected"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                v-model="dataFromSelect.dataPlace"
                id="places"
                label="vehicle_places__name"
                :options="optionsForSelect.places"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-between tw-mb-[6px]"
            ref="vehicles__mark_id"
          >
            <span class="tw-app-input-container-label-type-2">
              {{ dataLang["vehicles-page__modal__tab-object__column-1__mark"] }}
            </span>
            <div class="d-flex align-items-center gap-5">
              <div class="multiselect-type-2">
                <BaseSelect
                  style="width: 271px"
                  @input="setSelected"
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  v-model="dataFromSelect.dataMark"
                  id="mark"
                  label="vehicle_marks__name"
                  :options="optionsForSelect.marks"
                >
                  <template slot="noOptions">{{
                    dataLang["select_empty"]
                  }}</template>
                  <template slot="noResult">{{
                    dataLang["select_search_empty"]
                  }}</template
                  ><template slot="selectedLabel">{{
                    dataLang["select_selected"]
                  }}</template>
                  <template slot="deselectLabel">{{
                    dataLang["select_unselect"]
                  }}</template>
                </BaseSelect>
              </div>
              <button
                class="tw-app-btn-primary !tw-bg-[#F1F3F5] !tw-px-[9px]"
                @click="onAddMark"
              >
                <img
                  :src="require(`@/assets/icons/add-dark.svg`)"
                  width="8"
                  height="8"
                />
              </button>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-between tw-mb-[6px]"
            ref="vehicles__model_id"
          >
            <span class="tw-app-input-container-label-type-2">
              {{
                dataLang["vehicles-page__modal__tab-object__column-1__model"]
              }}
            </span>
            <div class="d-flex align-items-center gap-5">
              <div class="multiselect-type-2">
                <BaseSelect
                  style="width: 271px"
                  @input="setSelected"
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  v-model="dataFromSelect.dataModel"
                  id="model"
                  label="vehicle_examples__model"
                  :options="optionsForSelect.models"
                >
                  <template slot="noOptions">{{
                    dataLang["select_empty"]
                  }}</template>
                  <template slot="noResult">{{
                    dataLang["select_search_empty"]
                  }}</template
                  ><template slot="selectedLabel">{{
                    dataLang["select_selected"]
                  }}</template>
                  <template slot="deselectLabel">{{
                    dataLang["select_unselect"]
                  }}</template>
                </BaseSelect>
              </div>

              <button
                class="tw-app-btn-primary !tw-bg-[#F1F3F5] !tw-px-[9px]"
                @click="onAddModel"
              >
                <img
                  :src="require(`@/assets/icons/add-dark.svg`)"
                  width="8"
                  height="8"
                />
              </button>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-between tw-mb-[6px]"
            ref="vehicle_cars__body_generation"
          >
            <span class="tw-app-input-container-label-type-2">
              {{
                dataLang[
                  "vehicles-page__modal__tab-object__column-1__body_generation"
                ]
              }}
            </span>
            <div class="d-flex align-items-center gap-5">
              <div class="multiselect-type-2">
                <BaseSelect
                  style="width: 198px"
                  @input="setSelected"
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  v-model="dataFromSelect.dataGeneration"
                  id="generation"
                  label="car_examples__body_generation"
                  :options="optionsForSelect.generation"
                >
                  <template slot="noOptions">{{
                    dataLang["select_empty"]
                  }}</template>
                  <template slot="noResult">{{
                    dataLang["select_search_empty"]
                  }}</template
                  ><template slot="selectedLabel">{{
                    dataLang["select_selected"]
                  }}</template>
                  <template slot="deselectLabel">{{
                    dataLang["select_unselect"]
                  }}</template>
                </BaseSelect>
              </div>
              <button
                class="tw-app-btn-primary !tw-bg-[#F1F3F5] !tw-px-[9px]"
                @click="onAddModel"
              >
                <img
                  :src="require(`@/assets/icons/add-dark.svg`)"
                  width="8"
                  height="8"
                />
              </button>
            </div>
          </div>
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            :disabled="true"
            :width="'231'"
            class="tw-mb-[6px]"
            input-name="vehicle_cars__body_type"
            :value="dataForModal.vehicle_cars__body_type"
            :name-sign="
              dataLang['vehicles-page__modal__tab-object__column-1__body_type']
            "
          >
          </BaseInputNew>
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            :disabled="true"
            :width="'231'"
            class="tw-mb-[6px]"
            input-name="vehicle_cars__count_doors"
            :value="dataForModal.vehicle_cars__count_doors"
            :name-sign="
              dataLang['vehicles-page__modal__tab-object__column-1__doors']
            "
          >
          </BaseInputNew>
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            :disabled="true"
            :width="'231'"
            class="tw-mb-[6px]"
            input-name="vehicle_cars__count_places"
            :value="dataForModal.vehicle_cars__count_places"
            :name-sign="
              dataLang['vehicles-page__modal__tab-object__column-1__seats']
            "
          >
          </BaseInputNew>
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            :disabled="true"
            :width="'231'"
            class="tw-mb-[6px]"
            input-name="vehicle_cars__trunk_volume"
            :value="dataForModal.vehicle_cars__trunk_volume"
            :name-sign="
              dataLang['vehicles-page__modal__tab-object__column-1__trail']
            "
          >
          </BaseInputNew>
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            :disabled="true"
            :width="'231'"
            class="tw-mb-[6px]"
            input-name="vehicle_cars__ground_clearance"
            :value="dataForModal.vehicle_cars__ground_clearance"
            :name-sign="
              dataLang['vehicles-page__modal__tab-object__column-1__clearence']
            "
          >
          </BaseInputNew>
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            :disabled="true"
            :width="'231'"
            class="tw-mb-[6px]"
            input-name="vehicle_cars__tank_capacity"
            :value="dataForModal.vehicle_cars__tank_capacity"
            :name-sign="
              dataLang['vehicles-page__modal__tab-object__column-1__tank']
            "
          >
          </BaseInputNew>
          <!-- <BaseTextarea placeholder="" :disabled="true" :width="'219'" class="fsc-11" inputClass="fsc-11"
            @onInput="updateValue" minHeight="126" :maxLength="499" :resize="false"
            input-name="vehicles__adv_description" :value="dataForModal.vehicles__adv_description" :name-sign="dataLang[
              'vehicles-page__modal__tab-object__column-1__adv_description'
            ]
              ">
          </BaseTextarea>
          <span class="fsc-8 text-muted">{{ lengthDescription }} / 500</span> -->
          <!-- <BaseCheckboxV2Vue placeholder="" v-for="(item, index) in listAccessPage" :key="index"
                                input-name="checkboxx" v-model="listUpdateAccessPage[index].employee_menu_rules__state"
                                @oncheckeds="updateValueListAccess(listUpdateAccessPage[index])">Люк</BaseCheckboxV2Vue> -->
        </div>
      </div>
      <div class="col-4 d-flex flex-column">
        <div
          class="tw-py-[10px] tw-px-[15px] tw-rounded-[5px] tw-overflow-hidden tw-bg-white overflow-visible tw-mb-[6px]"
        >
          <div class="tw-mb-[6px] d-flex">
            <span class="fsc-12 fw-bolder tw-text-forTitle"
              >{{
                dataLang["vehicles-page__modal__tab-object__column-2__header"]
              }}
            </span>
          </div>
          <div class="tw-mb-[6px]" ref="vehicles__year_release">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'219'"
              @input="updateValue"
              input-name="vehicles__year_release"
              :value="dataForModal.vehicles__year_release"
              inputRef="vehicles__year_release"
              inputMask="0000"
              maxLength="4"
              :name-sign="
                dataLang['vehicles-page__modal__tab-object__column-2__year']
              "
            >
            </BaseInputNew>
            <!-- <span class="tw-app-input-container-label-type-2">
              {{ dataLang['vehicles-page__modal__tab-object__column-2__year'] }}
            </span>
            <BaseSelect
              style="width: 217px"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              @input="setSimpleSelect"
              v-model="dataFromSelect.dataYears"
              label="label"
              :options="optionsForSelect.years"
            >
              <template slot="noOptions">{{
                dataLang['select_empty']
              }}</template>
              <template slot="noResult">{{
                dataLang['select_search_empty']
              }}</template
              ><template slot="selectedLabel">{{
                dataLang['select_selected']
              }}</template>
              <template slot="deselectLabel">{{
                dataLang['select_unselect']
              }}</template>
            </BaseSelect> -->
          </div>
          <div
            class="d-flex align-items-center justify-content-between tw-mb-[6px]"
            ref="vehicle_cars__drive"
          >
            <span class="tw-app-input-container-label-type-2">
              {{
                dataLang["vehicles-page__modal__tab-object__column-2__drive"]
              }}
            </span>
            <div class="multiselect-type-2">
              <BaseSelect
                style="width: 217px"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                @input="setSimpleSelect"
                v-model="dataFromSelect.dataDrive"
                label="label"
                :options="selectsData.vehicle_cars__drive"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-between tw-mb-[6px]"
            ref="vehicles__color"
          >
            <span class="tw-app-input-container-label-type-2">
              {{
                dataLang["vehicles-page__modal__tab-object__column-2__color"]
              }}
            </span>
            <div class="multiselect-type-2">
              <BaseSelect
                style="width: 217px"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                @input="setSimpleSelect"
                v-model="dataFromSelect.dataColor"
                label="label"
                :options="selectsData.vehicles__color"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-between tw-mb-[6px]"
            ref="vehicle_cars__kpp"
          >
            <span class="tw-app-input-container-label-type-2">
              {{ dataLang["vehicles-page__modal__tab-object__column-2__kpp"] }}
            </span>
            <div class="multiselect-type-2">
              <BaseSelect
                style="width: 217px"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                @input="setSimpleSelect"
                v-model="dataFromSelect.dataKpp"
                id="city"
                label="label"
                :options="selectsData.vehicle_cars__kpp"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>
          </div>
          <div class="d-flex align-items-center gap-5 wp-100 tw-mb-[6px]">
            <div
              class="d-flex align-items-center justify-content-between flex-grow-1"
              ref="vehicles__type_engine"
            >
              <span class="tw-app-input-container-label-type-2">
                {{
                  dataLang[
                    "vehicles-page__modal__tab-object__column-2__engine_type"
                  ]
                }}
              </span>
              <div class="multiselect-type-2">
                <BaseSelect
                  style="width: 105px"
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  @input="setSimpleSelect"
                  v-model="dataFromSelect.dataTypeEngine"
                  label="label"
                  :options="selectsData.vehicles__type_engine"
                >
                  <div slot="no-options">Пока нет опций</div>
                  <div slot="no-result">Ничего не найдено</div>
                </BaseSelect>
              </div>
            </div>
            <div ref="vehicles__type_petrol">
              <div class="multiselect-type-2">
                <BaseSelect
                  style="width: 105px"
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  @input="setSimpleSelect"
                  v-model="dataFromSelect.dataPetrol"
                  label="label"
                  :options="selectsData.vehicles__type_petrol"
                  :max-height="500"
                >
                  <template slot="noOptions">{{
                    dataLang["select_empty"]
                  }}</template>
                  <template slot="noResult">{{
                    dataLang["select_search_empty"]
                  }}</template
                  ><template slot="selectedLabel">{{
                    dataLang["select_selected"]
                  }}</template>
                  <template slot="deselectLabel">{{
                    dataLang["select_unselect"]
                  }}</template>
                </BaseSelect>
              </div>
            </div>
          </div>

          <div ref="vehicles__engine_volume">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'219'"
              class="tw-mb-[6px]"
              input-name="vehicles__engine_volume"
              @input="updateValue"
              :value="dataForModal.vehicles__engine_volume"
              :name-sign="
                dataLang[
                  'vehicles-page__modal__tab-object__column-2__engine_volume'
                ]
              "
              inputRef="vehicles__engine_volume"
              inputMask="0.0"
            >
            </BaseInputNew>
          </div>
          <div ref="vehicles__engine_power">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'219'"
              class="tw-mb-[6px]"
              input-name="vehicles__engine_power"
              @input="updateValue"
              inputRef="vehicles__engine_power"
              inputMask="000000000"
              :value="dataForModal.vehicles__engine_power"
              :name-sign="
                dataLang[
                  'vehicles-page__modal__tab-object__column-2__engine_power'
                ]
              "
            >
            </BaseInputNew>
          </div>
          <div ref="vehicles__flow">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'219'"
              class=""
              input-name="vehicles__flow"
              @input="updateValue"
              inputRef="vehicles__flow"
              inputMask="000000000"
              :value="dataForModal.vehicles__flow"
              :name-sign="
                dataLang[
                  'vehicles-page__modal__tab-object__column-2__fuel_consumption'
                ]
              "
            >
            </BaseInputNew>
          </div>
        </div>
        <div
          class="tw-px-[15px] tw-py-[10px] tw-rounded-[5px] tw-overflow-hidden tw-bg-white flex-grow-1"
        >
          <div class="tw-mb-[6px] d-flex">
            <span class="fsc-12 fw-bolder tw-text-forTitle"
              >Комплектация объекта
            </span>
          </div>
          <div
            class="d-flex flex-column w-full fsc-11 tw-text-forText"
            style="gap: 3px; line-height: 14px"
          >
            <div
              class="px-10 w-full d-flex justify-content-between tw-pb-[2px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
            >
              <div class="">Безопасность</div>
              <div class="">0</div>
            </div>
            <div
              class="px-10 w-full d-flex justify-content-between tw-pb-[2px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
            >
              <div class="">Комфорт</div>
              <div class="">0</div>
            </div>
            <div
              class="px-10 w-full d-flex justify-content-between tw-pb-[2px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
            >
              <div class="">Мультимедиа</div>
              <div class="">0</div>
            </div>
            <div
              class="px-10 w-full d-flex justify-content-between tw-pb-[2px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
            >
              <div class="">Обзор</div>
              <div class="">0</div>
            </div>
            <div
              class="px-10 w-full d-flex justify-content-between tw-pb-[2px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
            >
              <div class="">Защита от угона</div>
              <div class="">0</div>
            </div>
            <div
              class="px-10 w-full d-flex justify-content-between tw-pb-[2px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
            >
              <div class="">Элементы экстерьера</div>
              <div class="">0</div>
            </div>
            <div
              class="px-10 w-full d-flex justify-content-between tw-pb-[2px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
            >
              <div class="">Салон</div>
              <div class="">0</div>
            </div>
            <div
              class="px-10 w-full d-flex justify-content-between tw-pb-[2px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
            >
              <div class="">Прочее</div>
              <div class="">0</div>
            </div>
            <div
              class="px-10 w-full d-flex justify-content-between tw-pb-[2px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-forLine"
              style=""
            >
              <div class="text-muted"></div>
              <div class="text-muted fw-bolder fsc-12">0</div>
            </div>
          </div>
          <div
            class="d-flex w-full fsc-12 justify-content-end text-decoration-underline tw-text-forTitle tw-mt-[5px]"
          >
            <div>Выбрать</div>
          </div>
        </div>
      </div>
      <div class="col-4 d-flex flex-column">
        <div
          class="tw-py-[10px] tw-px-[15px] tw-rounded-[5px] tw-overflow-hidden tw-bg-white mb-10"
        >
          <div class="mb-15 d-flex">
            <span class="fsc-12 fw-bolder tw-text-forTitle">{{
              dataLang["vehicles-page__modal__tab-object__column-3__header"]
            }}</span>
          </div>
          <div ref="vehicles__gosnumber">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'192'"
              class="mb-10"
              input-name="vehicles__gosnumber"
              @input="updateValue"
              :value="dataForModal.vehicles__gosnumber"
              :name-sign="
                dataLang[
                  'vehicles-page__modal__tab-object__column-3__gosnumber'
                ]
              "
              inputRef="vehicles__gosnumber"
              inputMask="a000aa000"
              maxLength="9"
            >
            </BaseInputNew>
          </div>
          <div ref="vehicles__sts">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'192'"
              class="mb-10"
              input-name="vehicles__sts"
              @input="updateValue"
              :value="dataForModal.vehicles__sts"
              :name-sign="
                dataLang['vehicles-page__modal__tab-object__column-3__sts_text']
              "
            >
            </BaseInputNew>
          </div>
          <div ref="vehicles__sts_date">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'192'"
              class="mb-10"
              input-name="vehicles__sts_date"
              @input="updateValue"
              :value="dataForModal.vehicles__sts_date"
              :name-sign="
                dataLang['vehicles-page__modal__tab-object__column-3__sts_date']
              "
              inputRef="vehicles__sts_date"
              inputMask="00.00.0000"
              maxLength="10"
            >
            </BaseInputNew>
          </div>
          <div
            class="d-flex align-items-center justify-content-between mb-10"
            ref="vehicles__owner_id"
          >
            <span class="tw-app-input-container-label-type-2">
              {{
                dataLang["vehicles-page__modal__tab-object__column-3__owner"]
              }}
            </span>
            <div class="multiselect-type-2">
              <BaseSelect
                style="width: 190px"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                @input="setSelectedOwner"
                v-model="dataFromSelect.dataOwner"
                label="label"
                :options="optionsForSelect.owners"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>
          </div>
          <div ref="vehicles__pts">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'192'"
              class="mb-10"
              input-name="vehicles__pts"
              @input="updateValue"
              :value="dataForModal.vehicles__pts"
              :name-sign="
                dataLang['vehicles-page__modal__tab-object__column-3__pts_text']
              "
            >
            </BaseInputNew>
          </div>
          <div ref="vehicles__pts_date">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'192'"
              class="mb-10"
              input-name="vehicles__pts_date"
              @input="updateValue"
              :value="dataForModal.vehicles__pts_date"
              :name-sign="
                dataLang['vehicles-page__modal__tab-object__column-3__pts_date']
              "
              inputRef="vehicles__pts_date"
              inputMask="00.00.0000"
              maxLength="10"
            >
            </BaseInputNew>
          </div>
          <div ref="vehicles__pts_owner">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'192'"
              class="mb-10"
              input-name="vehicles__pts_owner"
              @input="updateValue"
              :value="dataForModal.vehicles__pts_owner"
              :name-sign="
                dataLang[
                  'vehicles-page__modal__tab-object__column-3__pts_owner'
                ]
              "
            >
            </BaseInputNew>
          </div>
          <div ref="vehicles__vin">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'192'"
              class=""
              input-name="vehicles__vin"
              @input="updateValue"
              :value="dataForModal.vehicles__vin"
              :name-sign="
                dataLang['vehicles-page__modal__tab-object__column-3__pts_vin']
              "
            >
            </BaseInputNew>
          </div>
        </div>
        <div
          class="tw-py-[10px] tw-px-[15px] tw-rounded-[5px] tw-overflow-hidden tw-bg-white mb-10"
        >
          <div
            class="d-flex justify-content-between align-items-center gap-5"
            ref="vehicles__cost"
          >
            <div class="fsc-11 tw-text-forText" style="line-height: 14px">
              Стоимость объекта <br />
              (на момент закупки)
            </div>
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              placeholder=""
              :width="'192'"
              class="flex-shrink-0"
              style=""
              signClass=""
              input-name="vehicles__cost"
              @input="updateValue"
              :value="dataForModal.vehicles__cost"
              name-sign=""
            >
            </BaseInputNew>
          </div>
        </div>
        <div class="d-flex gap-10 flex-grow-1">
          <!-- <div
            class="rounded-5 min-h-172 wp-50 d-flex flex-column justify-content-center align-items-center text-white"
            style="background-color: rgba(35, 177, 77, 1)"
          >
            <span class="fw-bold fsc-36 lh-1">{{
              dataForModal.vehicles__rayting
            }}</span>
            <span class="fsc-18">{{
              dataForModal.vehicles__rayting
                ? dataLang[
                    'vehicles-page__modal__tab-object__column-3__reyting'
                  ]
                : ''
            }}</span>
          </div> -->

          <div
            class="rounded-5 min-h-172 wp-50 d-flex flex-column gap-5 justify-content-center align-items-center text-white"
            v-if="modeOpenModal == 'edit'"
            :class="[
              dataForModal.vehicle_status__code == 'quarantine'
                ? 'bg-danger'
                : '',
            ]"
            :style="{
              backgroundColor:
                dataForModal.vehicle_status__code == 'success'
                  ? 'rgba(35, 177, 77, 1)'
                  : '',
            }"
          >
            <span class="fw-bold fsc-24 lh-1" @click="sendData">
              {{ dataForModal.vehicle_status__status }}</span
            >
            <div
              v-if="dataForModal.vehicle_status__code == 'quarantine'"
              style="
                height: 1px;
                background-color: white;
                width: 166px;
                margin-top: 21px;
                margin-bottom: 5px;
                margin-left: auto;
                margin-right: auto;
              "
            ></div>
            <div
              class="fsc-14 px-15 text-start wp-100"
              v-if="dataForModal.vehicle_status__code == 'quarantine'"
            >
              Причина:
            </div>
            <div
              class="fsc-11 px-15"
              v-if="dataForModal.vehicle_status__code == 'quarantine'"
            >
              На строке здоровья есть красные поля
            </div>
          </div>
          <div
            class="rounded-5 min-h-172 wp-50 d-flex flex-column justify-content-center align-items-center text-white text-center"
            :class="[
              !dataForModal.vehicles__agregator_state ? 'bg-danger' : '',
              !dataForModal.vehicles__agregator_state ? '' : 'gap-5',
            ]"
            v-if="modeOpenModal == 'edit'"
            :style="{
              backgroundColor: dataForModal.vehicles__agregator_state
                ? 'rgba(35, 177, 77, 1)'
                : '',
            }"
          >
            <!-- register_objects_car_agregator_status_false -->
            <span
              class="fsc-18 lh-1"
              v-if="dataForModal.vehicles__agregator_state"
            >
              {{ dataLang["register_objects_car_agregator_status_true"] }}
              <br />
              {{ dataLang["register_objects_car_text_1"] }}</span
            >
            <div
              class="fsc-18 lh-1"
              v-if="!dataForModal.vehicles__agregator_state"
            >
              {{ dataLang["register_objects_car_agregator_status_false"] }}

              <br />
              {{ dataLang["register_objects_car_text_1"] }}
            </div>
            <div
              v-if="!dataForModal.vehicles__agregator_state"
              style="
                height: 1px;
                background-color: white;
                width: 166px;
                margin-top: 21px;
                margin-bottom: 5px;
                margin-left: auto;
                margin-right: auto;
              "
            ></div>
            <div
              class="fsc-14 px-15 text-start wp-100"
              v-if="!dataForModal.vehicles__agregator_state"
            >
              Вероятные причины:
            </div>
            <div
              class="fsc-11 px-15 text-start"
              v-if="!dataForModal.vehicles__agregator_state"
            >
              1. Статус “Карантин” <br />2. Фотогалерея не допущена <br />
              3. Настройка аренды не выбрана
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddModelModal />
    <AddMarkModal />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import Modal from "@/components/Modals.vue";
import NewModal from "@/components/NewModal.vue";
import EventBus from "@/event-bus.js";
import BaseTextarea from "@/components/ui/BaseTextarea.vue";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import OwnersService from "@/api/OwnersService.js";
import VehicleMarksService from "@/api/VehicleMarksService.js";
import SelectsService from "@/api/SelectsService.js";
import VehicleTypeAndCharacteristicsService from "@/api/VehicleTypeAndCharacteristicsService.js";
import TransportVehiclesService from "@/api/TransportVehiclesService.js";
import GlobalSettingService from "@/api/GlobalSettingService.js";
import ObjectsService from "@/api/ObjectsService";
import GeneralService from "@/api/GeneralService";
import AddModelModal from "@/views/marks-modals/AddModelModal.vue";
import AddMarkModal from "@/views/marks-modals/AddMarkModal.vue";
export default {
  components: {
    Modal,
    NewModal,
    BaseTextarea,
    VueTabs,
    VTab,
    AddMarkModal,
    AddModelModal,
  },

  props: {
    modeOpenModal: {
      type: String,
      default: "create",
    },

    currentOpenedId: {
      type: Number,
    },
  },
  data() {
    return {
      updatedValues: {},
      dataForModal: {},
      editData: {},
      modelName: "",
      markName: "",
      loadingNew: false,
      dataFromSelect: {
        dataCity: [],
        dataPlace: [],
        dataMark: [],
        dataModel: [],
        dataGeneration: [],
        dataYears: [],
        dataColor: [],
        dataDrive: [],
        dataKpp: [],
        dataTypeEngine: [],
        dataLuk: [],
        dataFarcop: [],
        dataReyling: [],
        dataTon: [],
        dataMaterial: [],
        dataConditioner: [],
        dataMaterial: [],
        dataOwner: [],
        dataPetrol: [],
        dataMultimedia: [],
      },
      optionsForSelect: {
        cities: [],
        marks: [],
        places: [],
        models: [],
        generation: [],
        owners: [],
        years: [],
      },
      selectsData: {
        vehicle_cars__drive: [],
        vehicles__color: [],
        vehicle_cars__kpp: [],
        vehicles__type_engine: [],
        vehicle_cars__luk: [],
        vehicle_cars__farcop: [],
        vehicle_cars__reyling: [],
        vehicle_cars__ton: [],
        vehicle_cars__material: [],
        vehicle_cars__conditioner: [],
        vehicles__type_petrol: [],
        vehicle_cars__multimedia: [],
      },
      activeSelectRow: null,
      lengthDescription: 0,
    };
  },
  methods: {
    onAddMark() {
      this.$modal.show("addMarkModal", {
        callback: async (data) => {
          await this.getAllMarksList();
          // setSelected(dataFromSelect.dataMark)
          this.dataFromSelect.dataMark = this.optionsForSelect.marks.find(
            (x) => {
              return Number(x.vehicle_marks__id) == Number(data.data.id);
            }
          );
          this.setSelected(this.dataFromSelect.dataMark);
        },
      });
    },
    async onAddModel() {
      this.$modal.show("addModelModal", {
        additional: {
          ...(this.dataFromSelect?.dataMark?.vehicle_marks__id && {
            vehicle_marks__id: this.dataFromSelect.dataMark.vehicle_marks__id,
          }),
        },
        callback: async (data) => {
          await this.getAllExamples({
            vehicle_marks__id: data.data.data.rows[0].vehicle_examples__mark_id,
          });

          this.dataFromSelect.dataModel = this.optionsForSelect.models.find(
            (x) => {
              return (
                Number(x.car_examples__id) ==
                Number(data.data.data.rows[0].car_examples__id)
              );
            }
          );

          this.setSelected(this.dataFromSelect.dataModel);
          // this.setSelected(Object.assign(this.dataFromSelect.dataModel, {selectName: 'generation'} ))
        },
      });
    },
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      this.$emit("loadingModal", true);
      if (Object.keys(this.updatedValues).length) {
        if (this.modeOpenModal == "create") {
          // /caniuse/createObject

          TransportVehiclesService.create(
            Object.assign(this.updatedValues, { vehicles__type: "car" })
          )
            .then((data) => {
              this.validateData("", true);
              this.$toast.success("Запись добавлена");
              EventBus.$emit("contentLoaded");
              EventBus.$emit("updateContentData");
              callback(true, nameTab, oldTab, newTab, flagIsClose);
            })
            .catch((error) => {
              this.validateData(error.response.data.errors);
              this.$toast.error(error.response.data.message, {
                duration: 5000,
              });
              callback(false, nameTab, oldTab, newTab);
            });
        }
        if (this.modeOpenModal == "edit") {
          TransportVehiclesService.update(
            this.currentOpenedId,
            this.updatedValues
          )
            .then((data) => {
              this.validateData("", true);
              this.$toast.success("Данные успешно обновлены");
              callback(true, nameTab, oldTab, newTab, flagIsClose);
              EventBus.$emit("updateContentData");
            })
            .catch((error) => {
              if (error.response.data) {
                this.validateData(error.response.data.errors);
                this.$toast.error(error.response.data.message, {
                  duration: 5000,
                });
              } else {
                this.$toast.error("Ошибка загрузки", { duration: 5000 });
              }

              callback(false, nameTab, oldTab, newTab);
            });
        }
      } else {
        callback(true, "", oldTab, newTab, flagIsClose);
      }
    },
    validateData(listErrorsAndStatus, typeOfClose) {
      this.$emit("loadingModal", false);
      if (listErrorsAndStatus) {
        this.$emit("changeErrorInTab", true);
        Object.keys(listErrorsAndStatus).forEach((elem, index) => {
          if (this.$refs[elem]) {
            this.$refs[elem].classList.add("input-error");
          }
        });
      } else {
        if (typeOfClose && this.modeOpenModal == "create") {
          this.$modal.hide("vehicleSettingModal");
        }
      }
    },

    clearData() {
      this.updatedValues = {};
      for (const key in this.dataFromSelect) {
        this.dataFromSelect[key] = [];
      }
      this.modelName = "";
      this.markName = "";
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
      if (data.name == "vehicles__engine_volume" && !data.value.includes(".")) {
        let stringNew = data.value.split("").join(".");
        this.updatedValues[data.name] = stringNew;
      }
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
      if (data.name == "vehicles__adv_description") {
        this.lengthDescription = data.value.length;
      }
    },
    setSimpleSelect(data, id) {
      console.log(data.key, data.value);
      // vehicles__type_engine
      this.updatedValues[data.key] = data.value;

      if (data.value == "vehicle_engine_electro") {
        this.updateValue({ name: "vehicles__engine_volume", value: String(0) });
        this.dataForModal.vehicles__engine_volume = 0;
        this.updatedValues["vehicles__type_petrol"] = null;
        this.dataFromSelect.dataPetrol = { label: "Нет" };
      }
      if (this.$refs[data.key]) {
        this.$refs[data.key].classList.remove("input-error");
      }
    },
    computedDateForSelect(data) {
      if (data?.car_examples__body_year_starts) {
        let start = Number(data["car_examples__body_year_starts"].slice(0, 4));
        let end = Number(data["car_examples__body_year_ends"].slice(0, 4));
        let computedYears = end - start;
        for (let index = 0; index < computedYears; index++) {
          this.optionsForSelect.years.push({
            label: start + index,
            key: "vehicles__year_release",
            value: start + index,
          });
        }
      }
    },
    setSelectedOwner(data) {
      this.updatedValues["vehicles__owner_id"] = data.value;
      if (this.$refs["vehicles__owner_id"]) {
        this.$refs["vehicles__owner_id"].classList.remove("input-error");
      }
    },
    async getAllExamples(dataFromSelect) {
      await VehicleTypeAndCharacteristicsService.getAllByParams({
        params: {
          vehicleType: "car",
          limit: 10000,
          where: JSON.stringify([
            {
              field: "vehicle_examples__mark_id",
              value: dataFromSelect["vehicle_marks__id"],
            },
          ]),
        },
      })
        .then((data) => {
          let downResult = [];
          let resultArray = [];
          data.data.data.rows.forEach((el, index) => {
            if (
              !downResult.find(
                (x) =>
                  x == String(el.vehicle_examples__model).toLowerCase().trim()
              )
            ) {
              downResult.push(
                String(el.vehicle_examples__model).toLowerCase().trim()
              );
              resultArray.push(el);
            }
          });
          console.log("sorento" == "sorento");

          this.optionsForSelect.models = this.prepareLabelsForSelects(
            resultArray,
            "models"
          );

          this.dataFromSelect.dataModel = [];
          this.dataFromSelect.dataGeneration = [];
          this.optionsForSelect.years = [];
          this.dataFromSelect.dataYears = [];

          console.log(
            "Method: getAllExamples; Api: getAllByParams; Effects: [fillAfterSelectGeneration]"
          );
        })
        .catch((err) => console.error(err));
    },
    async setSelected(dataFromSelect) {
      if (dataFromSelect) {
        switch (dataFromSelect.selectName) {
          case "cities":
            GeneralService.get(
              `/places/table/main?where=[{"field":"vehicle_places__city_id","value":${dataFromSelect.cities__id}}]`
            )
              .then((data) => {
                console.log(data);

                this.optionsForSelect.places = this.prepareLabelsForSelects(
                  data.data.rows,
                  "place"
                );
              })
              .catch((err) => console.log(err));
            this.dataFromSelect.dataPlace = [];
            break;

          case "place":
            this.updatedValues.vehicles__place_id =
              dataFromSelect.vehicle_places__id;
            this.updatedValues.vehicles__company_id =
              dataFromSelect.vehicle_places__company_id;
            this.$refs["vehicles__place_id"].classList.remove("input-error");
            // this.updatedValues.vehicle_places__address = dataFromSelect.vehicle_places__address

            break;

          case "marks":
            this.markName = dataFromSelect.vehicle_marks__name;
            this.updatedValues.vehicles__mark_id =
              dataFromSelect.vehicle_marks__id;
            await this.getAllExamples(dataFromSelect);

            break;
          case "models":
            this.updatedValues.vehicles__model =
              dataFromSelect.vehicle_examples__model;
            this.modelName = dataFromSelect.vehicle_examples__model;

            VehicleTypeAndCharacteristicsService.getAll({
              params: {
                vehicleType: "car",
                // car_examples__id,
                fields: "car_examples__body_generation",
                where: JSON.stringify([
                  // {
                  //   field: 'car_examples__id',
                  //   value: dataFromSelect['car_examples__id']
                  // },
                  {
                    field: "vehicle_examples__model",
                    value: dataFromSelect["vehicle_examples__model"],
                  },
                ]),
              },
            })
              .then((data) => {
                this.optionsForSelect.generation = this.prepareLabelsForSelects(
                  data.data.data.rows,
                  "generation"
                );
                this.updatedValues.vehicles__name = `${this.markName} ${this.modelName}`;
                this.dataFromSelect.dataGeneration = [];
                this.optionsForSelect.years = [];
                this.dataFromSelect.dataYears = [];
                this.dataFromSelect.dataGeneration =
                  this.optionsForSelect.generation[0];
                this.fillAfterSelectGeneration(
                  this.optionsForSelect.generation[0]
                );
              })
              .catch((err) => console.log(err));

            break;
          case "generation":
            this.updatedValues = Object.assign(
              this.updatedValues,
              dataFromSelect
            );
            this.dataForModal = Object.assign(
              this.dataForModal,
              dataFromSelect
            );
            this.fillAfterSelectGeneration(dataFromSelect);
            this.$refs["vehicle_cars__body_generation"].classList.remove(
              "input-error"
            );

            break;
        }
      }
    },

    fillFirstSelectGeneration(dataFromSelect) {
      this.computedDateForSelect(dataFromSelect);
      this.dataForModal.vehicle_cars__body_generation =
        dataFromSelect.car_examples__body_generation;
      this.dataForModal.vehicle_cars__body_type =
        dataFromSelect.car_examples__body_type;
      this.dataForModal.vehicle_cars__vehicle_class =
        dataFromSelect.car_examples__vehicle_class;
      this.dataForModal.vehicle_cars__width =
        dataFromSelect.car_examples__width;
      this.dataForModal.vehicle_cars__height =
        dataFromSelect.car_examples__height;
      this.dataForModal.vehicle_cars__length =
        dataFromSelect.car_examples__length;
      this.dataForModal.vehicle_cars__count_doors =
        dataFromSelect.car_examples__count_doors;
      this.dataForModal.vehicle_cars__count_places =
        dataFromSelect.car_examples__count_places;
      this.dataForModal.vehicle_cars__ground_clearance =
        dataFromSelect.car_examples__ground_clearance;
      this.dataForModal.vehicle_cars__curb_weight =
        dataFromSelect.car_examples__curb_weight;
      this.dataForModal.vehicle_cars__full_weight =
        dataFromSelect.car_examples__full_weight;
      this.dataForModal.vehicle_cars__trunk_volume =
        dataFromSelect.car_examples__trunk_volume;
      this.dataForModal.vehicle_cars__tank_capacity =
        dataFromSelect.car_examples__tank_capacity;
    },

    fillAfterSelectGeneration(dataFromSelect) {
      if (dataFromSelect) {
        this.computedDateForSelect(dataFromSelect);
        this.dataForModal.vehicle_cars__body_generation =
          dataFromSelect.car_examples__body_generation;
        this.dataForModal.vehicle_cars__body_type =
          dataFromSelect.car_examples__body_type;
        this.dataForModal.vehicle_cars__vehicle_class =
          dataFromSelect.car_examples__vehicle_class;
        this.dataForModal.vehicle_cars__width =
          dataFromSelect.car_examples__width;
        this.dataForModal.vehicle_cars__height =
          dataFromSelect.car_examples__height;
        this.dataForModal.vehicle_cars__length =
          dataFromSelect.car_examples__length;
        this.dataForModal.vehicle_cars__count_doors =
          dataFromSelect.car_examples__count_doors;
        this.dataForModal.vehicle_cars__count_places =
          dataFromSelect.car_examples__count_places;
        this.dataForModal.vehicle_cars__ground_clearance =
          dataFromSelect.car_examples__ground_clearance;
        this.dataForModal.vehicle_cars__curb_weight =
          dataFromSelect.car_examples__curb_weight;
        this.dataForModal.vehicle_cars__full_weight =
          dataFromSelect.car_examples__full_weight;
        this.dataForModal.vehicle_cars__trunk_volume =
          dataFromSelect.car_examples__trunk_volume;
        this.dataForModal.vehicle_cars__tank_capacity =
          dataFromSelect.car_examples__tank_capacity;
        this.fillAfterSelectGenerationUpdateValues(dataFromSelect);
      } else {
        this.dataForModal.vehicle_cars__body_generation = "";
        this.dataForModal.vehicle_cars__body_type = "";
        this.dataForModal.vehicle_cars__vehicle_class = "";
        this.dataForModal.vehicle_cars__width = "";
        this.dataForModal.vehicle_cars__height = "";
        this.dataForModal.vehicle_cars__length = "";
        this.dataForModal.vehicle_cars__count_doors = "";
        this.dataForModal.vehicle_cars__count_places = "";
        this.dataForModal.vehicle_cars__ground_clearance = "";
        this.dataForModal.vehicle_cars__curb_weight = "";
        this.dataForModal.vehicle_cars__full_weight = "";
        this.dataForModal.vehicle_cars__trunk_volume = "";
        this.dataForModal.vehicle_cars__tank_capacity = "";
        this.fillAfterSelectGenerationUpdateValues();
      }
    },

    fillAfterSelectGenerationUpdateValues(dataFromSelect) {
      if (dataFromSelect) {
        this.updatedValues.vehicle_cars__body_generation =
          dataFromSelect.car_examples__body_generation;
        this.updatedValues.vehicle_cars__body_type =
          dataFromSelect.car_examples__body_type;
        this.updatedValues.vehicle_cars__vehicle_class =
          dataFromSelect.car_examples__vehicle_class;
        this.updatedValues.vehicle_cars__width =
          dataFromSelect.car_examples__width;
        this.updatedValues.vehicle_cars__height =
          dataFromSelect.car_examples__height;
        this.updatedValues.vehicle_cars__length =
          dataFromSelect.car_examples__length;
        this.updatedValues.vehicle_cars__count_doors =
          dataFromSelect.car_examples__count_doors;
        this.updatedValues.vehicle_cars__count_places =
          dataFromSelect.car_examples__count_places;
        this.updatedValues.vehicle_cars__ground_clearance =
          dataFromSelect.car_examples__ground_clearance;
        this.updatedValues.vehicle_cars__curb_weight =
          dataFromSelect.car_examples__curb_weight;
        this.updatedValues.vehicle_cars__full_weight =
          dataFromSelect.car_examples__full_weight;
        this.updatedValues.vehicle_cars__trunk_volume =
          dataFromSelect.car_examples__trunk_volume;
        this.updatedValues.vehicle_cars__tank_capacity =
          dataFromSelect.car_examples__tank_capacity;
      } else {
        this.updatedValues.vehicle_cars__body_generation = "";
        this.updatedValues.vehicle_cars__body_type = "";
        this.updatedValues.vehicle_cars__vehicle_class = "";
        this.updatedValues.vehicle_cars__width = "";
        this.updatedValues.vehicle_cars__height = "";
        this.updatedValues.vehicle_cars__length = "";
        this.updatedValues.vehicle_cars__count_doors = "";
        this.updatedValues.vehicle_cars__count_places = "";
        this.updatedValues.vehicle_cars__ground_clearance = "";
        this.updatedValues.vehicle_cars__curb_weight = "";
        this.updatedValues.vehicle_cars__full_weight = "";
        this.updatedValues.vehicle_cars__trunk_volume = "";
        this.updatedValues.vehicle_cars__tank_capacity = "";
      }
    },

    prepareLabelsForSelects(data, keyDataFromFetch) {
      for (const key in data) {
        data[key]["selectName"] = keyDataFromFetch;
      }
      return data;
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    async prepareKeysForModal(payloadData) {
      this.updatedValues = {};
      this.dataForModal = {};

      if (!payloadData) {
        for (const key in this.transportVehiclesData[0]) {
          this.dataForModal[key] = null;
          if (key == "vehicles__sts_file") {
          }
        }
      } else {
        if (this.modeOpenModal == "edit") {
          if (payloadData.vehicles__adv_description) {
            this.lengthDescription =
              payloadData.vehicles__adv_description.length;
          }

          Promise.all([
            GeneralService.get("/places")
              .then((data) => {
                this.optionsForSelect.places = this.prepareLabelsForSelects(
                  data.data.places.rows,
                  "place"
                );
              })
              .catch((err) => console.log(err)),

            await this.getAllExamples({
              vehicle_marks__id: payloadData["vehicles__mark_id"],
            }),
            VehicleTypeAndCharacteristicsService.getAll({
              params: {
                vehicleType: "car",
                fields: "vehicle_examples__id,car_examples__body_generation",
                where: JSON.stringify([
                  {
                    field: "vehicle_examples__mark_id",
                    value: payloadData["vehicles__mark_id"],
                  },
                  {
                    field: "vehicle_examples__model",
                    value: payloadData["vehicles__model"],
                  },
                ]),
              },
            })
              .then((data) => {
                this.optionsForSelect.generation = this.prepareLabelsForSelects(
                  data.data.data.rows,
                  "generation"
                );
                this.computedDateForSelect(data.data.data.rows[0]);
              })
              .catch((err) => console.log(err)),
          ]).then(() => {
            this.$emit("loadingModal", false);

            this.dataForModal = Object.assign({}, payloadData);

            this.dataForModal.vehicles__pts_date = this.dataForModal
              .vehicles__pts_date
              ? this.dataForModal.vehicles__pts_date
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join(".")
              : "";

            this.dataForModal.vehicles__sts_date = this.dataForModal
              .vehicles__sts_date
              ? this.dataForModal.vehicles__sts_date
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join(".")
              : "";

            let middleCitiesForPlacesList = this.optionsForSelect.cities.find(
              (citiesId) =>
                citiesId.cities__id ==
                this.optionsForSelect.places.find(
                  (x) => x.vehicle_places__id == payloadData.vehicles__place_id
                ).vehicle_places__city_id
            ).cities__id;
            this.optionsForSelect.places = this.optionsForSelect.places.filter(
              (x) => x.vehicle_places__city_id == middleCitiesForPlacesList
            );
            this.dataFromSelect = {
              dataYears: { label: payloadData.vehicles__year_release },
              dataCity: {
                cities__name: this.optionsForSelect.cities.find(
                  (citiesId) =>
                    citiesId.cities__id ==
                    this.optionsForSelect.places.find(
                      (x) =>
                        x.vehicle_places__id == payloadData.vehicles__place_id
                    ).vehicle_places__city_id
                ).cities__name,
              },
              dataPlace: {
                vehicle_places__name: this.optionsForSelect.places.find(
                  (x) => x.vehicle_places__id == payloadData.vehicles__place_id
                ).vehicle_places__name,
              },
              dataMark: {
                vehicle_marks__name: payloadData.vehicles__name
                  ? payloadData.vehicles__name.trim().split(" ")[0]
                  : "",
              },
              dataModel: {
                vehicle_examples__model: payloadData.vehicles__model,
              },
              dataGeneration: this.optionsForSelect.generation.find(
                (x) =>
                  x.car_examples__body_generation ==
                  payloadData.vehicle_cars__body_generation
              ),
              dataColor: { label: payloadData.vehicles__color },
              dataDrive: { label: payloadData.vehicle_cars__drive },
              dataKpp: { label: payloadData.vehicle_cars__kpp },
              dataTypeEngine: { label: payloadData.vehicles__type_engine },
              dataLuk: { label: payloadData.vehicle_cars__luk },
              dataFarcop: { label: payloadData.vehicle_cars__farcop },
              dataReyling: { label: payloadData.vehicle_cars__reyling },
              dataTon: { label: payloadData.vehicle_cars__ton },
              dataMaterial: { label: payloadData.vehicle_cars__material },
              dataConditioner: { label: payloadData.vehicle_cars__conditioner },
              dataPetrol: { label: payloadData.vehicles__type_petrol ?? "Нет" },
              dataOwner: payloadData.vehicles__owner_id
                ? this.optionsForSelect.owners.find((x) => {
                    return x.value == payloadData.vehicles__owner_id;
                  })
                : null,
              dataMultimedia: {
                // this.optionsForSelect.owners.find(
                //   (x) => x.vehicle_owners__id == payloadData.vehicles__owner_id
                // ).vehicle_owners__name,
                label: payloadData.vehicle_cars__multimedia,
              },
            };
            console.log(this.dataFromSelect.dataOwner);
          });
        }
      }
    },

    async getAllMarksList() {
      await VehicleMarksService.getAll().then((data) => {
        this.optionsForSelect.marks = this.prepareLabelsForSelects(
          data.data.data,
          "marks"
        );
      });
    },

    ...mapActions("transportVehiclesModule", [
      "getHealth",
      "getTitle",
      "getTransportVehiclesAll",
      "editTransportVehiclesMultiple",
      "createTransportVehiclesData",
      "deleteTransportVehiclesData",
    ]),
  },
  mounted() {},

  created() {
    this.$emit("loadingModal", true);
    if (this.modeOpenModal == "edit") {
      this.getHealth(this.currentOpenedId);
      this.getTitle(this.currentOpenedId);
    }
    Promise.all([
      GeneralService.get("/objects/cities/places", {
        params: {
          limit: 3000,
        },
      })
        .then((data) => {
          this.optionsForSelect.cities = this.prepareLabelsForSelects(
            data.data.rows,
            "cities"
          );
        })
        .catch((e) => {
          console.log(e);
        }),
      VehicleMarksService.getAll().then((data) => {
        this.optionsForSelect.marks = this.prepareLabelsForSelects(
          data.data.data,
          "marks"
        );
      }),

      // OwnersService.getAll().then((data) => {
      //   this.optionsForSelect.owners = this.prepareLabelsForSelects(
      //     data.data.data.rows,
      //     'owners'
      //   )
      // }),
      GeneralService.get("/object-owners/select/list", {
        params: {
          limit: 3000,
        },
      })
        .then((data) => {
          this.optionsForSelect.owners = data.data.data.map((x) => {
            return {
              label: Object.values(x)[0],
              value: Object.keys(x)[0],
            };
          });
        })
        .catch((e) => {
          console.log(e);
        }),
      SelectsService.getAll().then((data) => {
        this.selectsData = this.prepareLabelsForDefaultSelects(
          data.data.data.rows,
          "allSelects",
          true
        );
      }),
      GlobalSettingService.getAll().then((data) => {
        if (this.modeOpenModal == "create") {
          this.dataForModal.vehicle_cars__range_oil_dvs =
            data.data.data.rows[0].company_settings__set_vehicle_interval_to_dvs;
          this.dataForModal.vehicle_cars__range_oil_kpp =
            data.data.data.rows[0].company_settings__set_vehicle_interval_to_akpp;
          this.updatedValues.vehicle_cars__range_oil_dvs =
            data.data.data.rows[0].company_settings__set_vehicle_interval_to_dvs;
          this.updatedValues.vehicle_cars__range_oil_kpp =
            data.data.data.rows[0].company_settings__set_vehicle_interval_to_akpp;
        }
      }),
    ]).then(() => {
      this.selectsData.vehicles__type_petrol.push({ label: "Нет" });

      if (this.modeOpenModal == "create") {
        this.$emit("loadingModal", false);
      }
      if (this.modeOpenModal == "edit") {
        console.log("edit");

        ObjectsService.getOne(this.currentOpenedId)
          .then((data) => {
            this.prepareKeysForModal(data.data.data.rows[0]);
          })
          .catch((err) => {});
      } else {
      }
      this.loadingNew = true;
    });
  },
  computed: {
    ...mapState("transportVehiclesModule", [
      "transportVehiclesData",
      "transportVehiclesLoadStatus",
      "paginationStateParams",
    ]),
    ...mapState("translationModule", ["dataLang"]),
    ...mapGetters("transportVehiclesModule", ["numPages"]),
  },
};
</script>

<style lang="scss" scoped></style>
